import type { ConnectorMappingForSettings } from "../../../http/deckDesigner/types/connectorMappings";
import type { DeckDesignerConfigurationFormValues } from "../../../http/deckDesigner/useAutoSaveDeckDesignerConfiguration";

// A criterion left out, or not picked yet, matches every connector mapping.
export type ConnectorMappingCriteria = Partial<
  Pick<
    DeckDesignerConfigurationFormValues,
    "substructureMaterial" | "fasteningType" | "groovingType" | "connectorFamily" | "secondaryItem"
  >
>;

export const filterConnectorMappings = (
  connectorMappings: ConnectorMappingForSettings[],
  { substructureMaterial, fasteningType, groovingType, connectorFamily, secondaryItem }: ConnectorMappingCriteria,
): ConnectorMappingForSettings[] =>
  connectorMappings.filter(
    (option) =>
      (!substructureMaterial || option.substructureMaterials.some((m) => m.code === substructureMaterial.code)) &&
      (!fasteningType || option.fasteningType.code === fasteningType.code) &&
      (!groovingType || option.groovingType.code === groovingType.code) &&
      (!connectorFamily || option.connectorFamily.code === connectorFamily.code) &&
      (!secondaryItem || option.secondaryItem?.item.id === secondaryItem.item.id),
  );
